export const WRAPPED_RICH_EDITOR_METHODS = ['addValue', 'blur', 'focus'];
export const RICH_EDITOR_REFERENCE_NAME = 'richEditor';
